import React, { useContext, useEffect, useMemo } from 'react';
import LookerReport from '@/pages/home/pages/report/Looker';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import { LayoutContext } from '@/pages/benchmark/state/LayoutContext';
import { getLogTypeId } from '@/pages/benchmark/utils/utils';

const Looker = () => {
  const { frameType, currentMenu } = useContext(LayoutContext);

  useEffect(() => {
    if (!currentMenu) {
      return;
    }
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '800501',
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/looker/report/${nameEn || ''}`,
      uidType: '', // 基准打点不包含uidType
      typeId: getLogTypeId(frameType),
    };
    buriedPoint(logObj);
  }, [currentMenu, frameType]);

  const { url, lookerModels } = useMemo(() => {
    const url = currentMenu?.url || '';
    const lookerModels = [currentMenu?.looker_models] || '';
    return { url, lookerModels };
  }, [currentMenu]);

  return (<>{url && <LookerReport url={url} models={lookerModels} />}</>);
};

export default Looker;